export const REGIONS = [
	{ id: "Western Europe", aliases: ["west europe"] },
	{ id: "Eastern Europe", aliases: ["east europe"] },
	{ id: "Northern Europe", aliases: ["north europe"] },
	{ id: "Southern Europe", aliases: ["south europe"] },
	{ id: "South Asia", aliases: ["southern asia"] },
	{ id: "Southeast Asia", aliases: ["south east asia"] },
	{ id: "East Asia", aliases: ["eastern asia", "far east"] },
	{ id: "Central Asia", aliases: [] },
	{ id: "Middle East", aliases: ["west asia"] },
	{ id: "North Africa", aliases: ["northern africa"] },
	{ id: "Sub-Saharan Africa", aliases: ["subsaharan africa"] },
	{ id: "North America", aliases: ["northern america"] },
	{ id: "South America", aliases: ["southern america", "latin america"] },
	{ id: "Central America", aliases: ["central am"] },
	{ id: "Caribbean", aliases: ["caribbean islands"] },
	{ id: "Oceania", aliases: ["pacific", "pacific islands"] },
	{ id: "Antarctica", aliases: [] },
	{ id: "Atlantic Ocean", aliases: ["atlantic"] },
	{ id: "North Atlantic", aliases: [] },
] as const;

export type RegionId = (typeof REGIONS)[number]["id"];

export const REGION_GROUPS: Partial<Record<string, RegionId[]>> = {
	europe: ["Western Europe", "Eastern Europe", "Northern Europe", "Southern Europe"],
	asia: ["South Asia", "Southeast Asia", "East Asia", "Central Asia"],
	africa: ["Sub-Saharan Africa", "North Africa"],
	america: ["North America", "South America", "Central America", "Caribbean"],
};

export interface CountryRecord {
	name: string;
	code: string;
	languages?: string[];
	flag_colors?: string[];
	region?: RegionId;
}

export const COUNTRIES: CountryRecord[] = [
	{
		"name": "Андорра",
		"code": "AD",
		"languages": ["catalan"],
		"flag_colors": ["blue", "yellow", "red"],
		"region": "Western Europe"
	},
	{
		"name": "ОАЭ",
		"code": "AE",
		"languages": ["arabic"],
		"flag_colors": ["red", "green", "white", "black"],
		"region": "Middle East"
	},
	{
		"name": "Афганистан",
		"code": "AF",
		"languages": ["dari", "pashto"],
		"flag_colors": ["black", "red", "green"],
		"region": "South Asia"
	},
	{
		"name": "Антигуа и Барбуда",
		"code": "AG",
		"languages": ["english"],
		"flag_colors": ["red", "black", "blue", "white", "yellow"],
		"region": "Caribbean"
	},
	{
		"name": "Ангилья",
		"code": "AI",
		"languages": ["english"],
		"flag_colors": ["blue", "white", "orange"],
		"region": "Caribbean"
	},
	{
		"name": "Албания",
		"code": "AL",
		"languages": ["albanian"],
		"flag_colors": ["red", "black"],
		"region": "Southern Europe"
	},
	{
		"name": "Армения",
		"code": "AM",
		"languages": ["armenian"],
		"flag_colors": ["red", "blue", "orange"],
		"region": "Middle East"
	},
	{
		"name": "Ангола",
		"code": "AO",
		"languages": ["portuguese"],
		"flag_colors": ["red", "black", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Антарктида",
		"code": "AQ",
		"languages": [],
		"flag_colors": [],
		"region": "Antarctica"
	},
	{
		"name": "Аргентина",
		"code": "AR",
		"languages": ["spanish"],
		"flag_colors": ["blue", "white", "yellow"],
		"region": "South America"
	},
	{
		"name": "Американское Самоа",
		"code": "AS",
		"languages": ["english", "samoan"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Oceania"
	},
	{
		"name": "Австрия",
		"code": "AT",
		"languages": ["german"],
		"flag_colors": ["red", "white"],
		"region": "Western Europe"
	},
	{
		"name": "Австралия",
		"code": "AU",
		"languages": ["english"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Oceania"
	},
	{
		"name": "Аруба",
		"code": "AW",
		"languages": ["dutch", "papiamento"],
		"flag_colors": ["blue", "yellow", "red", "white"],
		"region": "Caribbean"
	},
	{
		"name": "Аландские острова",
		"code": "AX",
		"languages": ["swedish"],
		"flag_colors": ["blue", "yellow", "red"],
		"region": "Northern Europe"
	},
	{
		"name": "Азербайджан",
		"code": "AZ",
		"languages": ["azerbaijani"],
		"flag_colors": ["blue", "red", "green", "white"],
		"region": "Middle East"
	},
	{
		"name": "Босния и Герцеговина",
		"code": "BA",
		"languages": ["bosnian", "croatian", "serbian"],
		"flag_colors": ["blue", "yellow", "white"],
		"region": "Southern Europe"
	},
	{
		"name": "Барбадос",
		"code": "BB",
		"languages": ["english"],
		"flag_colors": ["blue", "yellow", "black"],
		"region": "Caribbean"
	},
	{
		"name": "Бангладеш",
		"code": "BD",
		"languages": ["bengali"],
		"flag_colors": ["green", "red"],
		"region": "South Asia"
	},
	{
		"name": "Бельгия",
		"code": "BE",
		"languages": ["french", "dutch", "german"],
		"flag_colors": ["black", "yellow", "red"],
		"region": "Western Europe"
	},
	{
		"name": "Буркина-Фасо",
		"code": "BF",
		"languages": ["french"],
		"flag_colors": ["red", "green", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Болгария",
		"code": "BG",
		"languages": ["bulgarian"],
		"flag_colors": ["white", "green", "red"],
		"region": "Eastern Europe"
	},
	{
		"name": "Бахрейн",
		"code": "BH",
		"languages": ["arabic"],
		"flag_colors": ["red", "white"],
		"region": "Middle East"
	},
	{
		"name": "Бурунди",
		"code": "BI",
		"languages": ["kirundi", "french", "english"],
		"flag_colors": ["red", "green", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Бенин",
		"code": "BJ",
		"languages": ["french"],
		"flag_colors": ["green", "yellow", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Сен-Бартелеми",
		"code": "BL",
		"languages": ["french"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Бермудские острова",
		"code": "BM",
		"languages": ["english"],
		"flag_colors": ["blue", "white", "red"],
		"region": "North Atlantic"
	},
	{
		"name": "Бруней",
		"code": "BN",
		"languages": ["malay"],
		"flag_colors": ["yellow", "white", "black", "red"],
		"region": "Southeast Asia"
	},
	{
		"name": "Боливия",
		"code": "BO",
		"languages": ["spanish", "quechua", "aymara"],
		"flag_colors": ["red", "yellow", "green"],
		"region": "South America"
	},
	{
		"name": "Карибские Нидерланды",
		"code": "BQ",
		"languages": ["dutch", "papiamento", "english"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Бразилия",
		"code": "BR",
		"languages": ["portuguese"],
		"flag_colors": ["green", "yellow", "blue", "white"],
		"region": "South America"
	},
	{
		"name": "Багамские острова",
		"code": "BS",
		"languages": ["english"],
		"flag_colors": ["blue", "yellow", "black"],
		"region": "Caribbean"
	},
	{
		"name": "Бутан",
		"code": "BT",
		"languages": ["dzongkha"],
		"flag_colors": ["yellow", "orange", "white"],
		"region": "South Asia"
	},
	{
		"name": "Остров Буве",
		"code": "BV",
		"languages": [],
		"flag_colors": ["red", "white", "blue"],
		"region": "Antarctica"
	},
	{
		"name": "Ботсвана",
		"code": "BW",
		"languages": ["english", "tswana"],
		"flag_colors": ["blue", "black", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Беларусь",
		"code": "BY",
		"languages": ["belarusian", "russian"],
		"flag_colors": ["red", "green", "white"],
		"region": "Eastern Europe"
	},
	{
		"name": "Белиз",
		"code": "BZ",
		"languages": ["english"],
		"flag_colors": ["blue", "red", "white"],
		"region": "Central America"
	},
	{
		"name": "Канада",
		"code": "CA",
		"languages": ["english", "french"],
		"flag_colors": ["red", "white"],
		"region": "North America"
	},
	{
		"name": "Кокосовые острова",
		"code": "CC",
		"languages": ["english"],
		"flag_colors": ["green", "red", "yellow", "white"],
		"region": "Southeast Asia"
	},
	{
		"name": "Демократическая Республика Конго",
		"code": "CD",
		"languages": ["french", "lingala", "swahili", "tshiluba", "kikongo"],
		"flag_colors": ["blue", "red", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Центральноафриканская Республика",
		"code": "CF",
		"languages": ["french", "sango"],
		"flag_colors": ["blue", "white", "green", "yellow", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Республика Конго",
		"code": "CG",
		"languages": ["french", "lingala", "kituba"],
		"flag_colors": ["green", "yellow", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Швейцария",
		"code": "CH",
		"languages": ["german", "french", "italian"],
		"flag_colors": ["red", "white"],
		"region": "Western Europe"
	},
	{
		"name": "Кот-д'Ивуар",
		"code": "CI",
		"languages": ["french"],
		"flag_colors": ["orange", "white", "green"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Острова Кука",
		"code": "CK",
		"languages": ["english", "cook islands maori"],
		"flag_colors": ["blue", "white"],
		"region": "Oceania"
	},
	{
		"name": "Чили",
		"code": "CL",
		"languages": ["spanish"],
		"flag_colors": ["white", "red", "blue"],
		"region": "South America"
	},
	{
		"name": "Камерун",
		"code": "CM",
		"languages": ["english", "french"],
		"flag_colors": ["green", "red", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Китай",
		"code": "CN",
		"languages": ["mandarin"],
		"flag_colors": ["red", "yellow"],
		"region": "East Asia"
	},
	{
		"name": "Колумбия",
		"code": "CO",
		"languages": ["spanish"],
		"flag_colors": ["yellow", "blue", "red"],
		"region": "South America"
	},
	{
		"name": "Коста-Рика",
		"code": "CR",
		"languages": ["spanish"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Central America"
	},
	{
		"name": "Куба",
		"code": "CU",
		"languages": ["spanish"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Кабо-Верде",
		"code": "CV",
		"languages": ["portuguese"],
		"flag_colors": ["blue", "white", "red", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Кюрасао",
		"code": "CW",
		"languages": ["dutch", "papiamento", "english"],
		"flag_colors": ["blue", "yellow", "white"],
		"region": "Caribbean"
	},
	{
		"name": "Остров Рождества",
		"code": "CX",
		"languages": ["english"],
		"flag_colors": ["green", "blue", "yellow", "white"],
		"region": "Oceania"
	},
	{
		"name": "Кипр",
		"code": "CY",
		"languages": ["greek", "turkish"],
		"flag_colors": ["white", "orange", "green"],
		"region": "Middle East"
	},
	{
		"name": "Чехия",
		"code": "CZ",
		"languages": ["czech"],
		"flag_colors": ["white", "red", "blue"],
		"region": "Eastern Europe"
	},
	{
		"name": "Германия",
		"code": "DE",
		"languages": ["german"],
		"flag_colors": ["black", "red", "yellow"],
		"region": "Western Europe"
	},
	{
		"name": "Джибути",
		"code": "DJ",
		"languages": ["arabic", "french", "afar", "somali"],
		"flag_colors": ["blue", "green", "white", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Дания",
		"code": "DK",
		"languages": ["danish"],
		"flag_colors": ["red", "white"],
		"region": "Northern Europe"
	},
	{
		"name": "Доминика",
		"code": "DM",
		"languages": ["english"],
		"flag_colors": ["green", "yellow", "black", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Доминиканская Республика",
		"code": "DO",
		"languages": ["spanish"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Caribbean"
	},
	{
		"name": "Алжир",
		"code": "DZ",
		"languages": ["arabic", "tamazight"],
		"flag_colors": ["green", "white", "red"],
		"region": "North Africa"
	},
	{
		"name": "Эквадор",
		"code": "EC",
		"languages": ["spanish"],
		"flag_colors": ["yellow", "blue", "red"],
		"region": "South America"
	},
	{
		"name": "Эстония",
		"code": "EE",
		"languages": ["estonian"],
		"flag_colors": ["blue", "black", "white"],
		"region": "Northern Europe"
	},
	{
		"name": "Египет",
		"code": "EG",
		"languages": ["arabic"],
		"flag_colors": ["red", "white", "black", "yellow"],
		"region": "North Africa"
	},
	{
		"name": "Западная Сахара",
		"code": "EH",
		"languages": ["arabic", "spanish"],
		"flag_colors": ["black", "white", "green", "red"],
		"region": "North Africa"
	},
	{
		"name": "Эритрея",
		"code": "ER",
		"languages": ["tigrinya", "arabic", "english"],
		"flag_colors": ["red", "green", "blue", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Испания",
		"code": "ES",
		"languages": ["spanish"],
		"flag_colors": ["red", "yellow"],
		"region": "Southern Europe"
	},
	{
		"name": "Эфиопия",
		"code": "ET",
		"languages": ["amharic", "oromo"],
		"flag_colors": ["green", "yellow", "red", "blue"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Европейский союз",
		"code": "EU",
		"languages": ["english", "french", "german"],
		"flag_colors": ["blue", "yellow"],
		"region": "Western Europe"
	},
	{
		"name": "Финляндия",
		"code": "FI",
		"languages": ["finnish", "swedish"],
		"flag_colors": ["white", "blue"],
		"region": "Northern Europe"
	},
	{
		"name": "Фиджи",
		"code": "FJ",
		"languages": ["english", "fijian", "hindi"],
		"flag_colors": ["blue", "white", "red", "yellow"],
		"region": "Oceania"
	},
	{
		"name": "Фолклендские острова",
		"code": "FK",
		"languages": ["english"],
		"flag_colors": ["blue", "white", "red", "yellow"],
		"region": "South America"
	},
	{
		"name": "Микронезия",
		"code": "FM",
		"languages": ["english"],
		"flag_colors": ["blue", "white"],
		"region": "Oceania"
	},
	{
		"name": "Фарерские острова",
		"code": "FO",
		"languages": ["faroese", "danish"],
		"flag_colors": ["white", "red", "blue"],
		"region": "Northern Europe"
	},
	{
		"name": "Франция",
		"code": "FR",
		"languages": ["french"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Western Europe"
	},
	{
		"name": "Габон",
		"code": "GA",
		"languages": ["french"],
		"flag_colors": ["green", "yellow", "blue"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Англия",
		"code": "GB-ENG",
		"languages": ["english"],
		"flag_colors": ["red", "white"],
		"region": "Western Europe"
	},
	{
		"name": "Северная Ирландия",
		"code": "GB-NIR",
		"languages": ["english", "irish"],
		"flag_colors": ["white", "red"],
		"region": "Western Europe"
	},
	{
		"name": "Шотландия",
		"code": "GB-SCT",
		"languages": ["english", "scottish gaelic"],
		"flag_colors": ["blue", "white"],
		"region": "Western Europe"
	},
	{
		"name": "Уэльс",
		"code": "GB-WLS",
		"languages": ["english", "welsh"],
		"flag_colors": ["green", "white", "red"],
		"region": "Western Europe"
	},
	{
		"name": "Великобритания",
		"code": "GB",
		"languages": ["english"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Western Europe"
	},
	{
		"name": "Гренада",
		"code": "GD",
		"languages": ["english"],
		"flag_colors": ["red", "yellow", "green", "black"],
		"region": "Caribbean"
	},
	{
		"name": "Грузия",
		"code": "GE",
		"languages": ["georgian"],
		"flag_colors": ["white", "red"],
		"region": "Middle East"
	},
	{
		"name": "Французская Гвиана",
		"code": "GF",
		"languages": ["french"],
		"flag_colors": ["green", "yellow", "red"],
		"region": "South America"
	},
	{
		"name": "Гернси",
		"code": "GG",
		"languages": ["english", "french"],
		"flag_colors": ["white", "red", "yellow"],
		"region": "Western Europe"
	},
	{
		"name": "Гана",
		"code": "GH",
		"languages": ["english"],
		"flag_colors": ["red", "yellow", "green", "black"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Гибралтар",
		"code": "GI",
		"languages": ["english"],
		"flag_colors": ["red", "white", "yellow"],
		"region": "Southern Europe"
	},
	{
		"name": "Гренландия",
		"code": "GL",
		"languages": ["kalaallisut", "danish"],
		"flag_colors": ["red", "white"],
		"region": "North America"
	},
	{
		"name": "Гамбия",
		"code": "GM",
		"languages": ["english"],
		"flag_colors": ["red", "blue", "green", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Гвинея",
		"code": "GN",
		"languages": ["french"],
		"flag_colors": ["red", "yellow", "green"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Гваделупа",
		"code": "GP",
		"languages": ["french"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Экваториальная Гвинея",
		"code": "GQ",
		"languages": ["spanish", "french", "portuguese"],
		"flag_colors": ["green", "white", "red", "blue", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Греция",
		"code": "GR",
		"languages": ["greek"],
		"flag_colors": ["blue", "white"],
		"region": "Southern Europe"
	},
	{
		"name": "Южная Георгия и Южные Сандвичевы острова",
		"code": "GS",
		"languages": [],
		"flag_colors": ["blue", "white", "yellow"],
		"region": "Atlantic Ocean"
	},
	{
		"name": "Гватемала",
		"code": "GT",
		"languages": ["spanish"],
		"flag_colors": ["blue", "white"],
		"region": "Central America"
	},
	{
		"name": "Гуам",
		"code": "GU",
		"languages": ["english", "chamorro"],
		"flag_colors": ["blue", "red"],
		"region": "Oceania"
	},
	{
		"name": "Гвинея-Бисау",
		"code": "GW",
		"languages": ["portuguese"],
		"flag_colors": ["red", "yellow", "green", "black"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Гайана",
		"code": "GY",
		"languages": ["english"],
		"flag_colors": ["green", "yellow", "red", "black", "white"],
		"region": "South America"
	},
	{
		"name": "Гонконг",
		"code": "HK",
		"languages": ["cantonese", "english"],
		"flag_colors": ["red", "white"],
		"region": "East Asia"
	},
	{
		"name": "Остров Херд и острова Макдональд",
		"code": "HM",
		"languages": [],
		"flag_colors": ["blue", "white", "red"],
		"region": "Oceania"
	},
	{
		"name": "Гондурас",
		"code": "HN",
		"languages": ["spanish"],
		"flag_colors": ["blue", "white"],
		"region": "Central America"
	},
	{
		"name": "Хорватия",
		"code": "HR",
		"languages": ["croatian"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Southern Europe"
	},
	{
		"name": "Гаити",
		"code": "HT",
		"languages": ["haitian creole", "french"],
		"flag_colors": ["blue", "red", "white"],
		"region": "Caribbean"
	},
	{
		"name": "Венгрия",
		"code": "HU",
		"languages": ["hungarian"],
		"flag_colors": ["red", "white", "green"],
		"region": "Eastern Europe"
	},
	{
		"name": "Индонезия",
		"code": "ID",
		"languages": ["indonesian"],
		"flag_colors": ["red", "white"],
		"region": "Southeast Asia"
	},
	{
		"name": "Ирландия",
		"code": "IE",
		"languages": ["english", "irish"],
		"flag_colors": ["green", "white", "orange"],
		"region": "Western Europe"
	},
	{
		"name": "Израиль",
		"code": "IL",
		"languages": ["hebrew", "arabic"],
		"flag_colors": ["blue", "white"],
		"region": "Middle East"
	},
	{
		"name": "Остров Мэн",
		"code": "IM",
		"languages": ["english", "manx"],
		"flag_colors": ["red", "yellow"],
		"region": "Western Europe"
	},
	{
		"name": "Индия",
		"code": "IN",
		"languages": ["hindi", "english"],
		"flag_colors": ["orange", "white", "green", "blue"],
		"region": "South Asia"
	},
	{
		"name": "Британская территория в Индийском океане",
		"code": "IO",
		"languages": ["english"],
		"flag_colors": ["blue", "white", "red", "yellow"],
		"region": "South Asia"
	},
	{
		"name": "Ирак",
		"code": "IQ",
		"languages": ["arabic", "kurdish"],
		"flag_colors": ["red", "white", "black", "green"],
		"region": "Middle East"
	},
	{
		"name": "Иран",
		"code": "IR",
		"languages": ["persian"],
		"flag_colors": ["green", "white", "red"],
		"region": "Middle East"
	},
	{
		"name": "Исландия",
		"code": "IS",
		"languages": ["icelandic"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Northern Europe"
	},
	{
		"name": "Италия",
		"code": "IT",
		"languages": ["italian"],
		"flag_colors": ["green", "white", "red"],
		"region": "Southern Europe"
	},
	{
		"name": "Джерси",
		"code": "JE",
		"languages": ["english", "french"],
		"flag_colors": ["white", "red", "yellow"],
		"region": "Western Europe"
	},
	{
		"name": "Ямайка",
		"code": "JM",
		"languages": ["english"],
		"flag_colors": ["green", "yellow", "black"],
		"region": "Caribbean"
	},
	{
		"name": "Иордания",
		"code": "JO",
		"languages": ["arabic"],
		"flag_colors": ["black", "white", "green", "red"],
		"region": "Middle East"
	},
	{
		"name": "Япония",
		"code": "JP",
		"languages": ["japanese"],
		"flag_colors": ["red", "white"],
		"region": "East Asia"
	},
	{
		"name": "Кения",
		"code": "KE",
		"languages": ["english", "swahili"],
		"flag_colors": ["black", "red", "green", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Киргизия",
		"code": "KG",
		"languages": ["kyrgyz", "russian"],
		"flag_colors": ["red", "yellow"],
		"region": "Central Asia"
	},
	{
		"name": "Камбоджа",
		"code": "KH",
		"languages": ["khmer"],
		"flag_colors": ["blue", "red", "white"],
		"region": "Southeast Asia"
	},
	{
		"name": "Кирибати",
		"code": "KI",
		"languages": ["english", "kiribati"],
		"flag_colors": ["red", "blue", "white", "yellow"],
		"region": "Oceania"
	},
	{
		"name": "Коморы",
		"code": "KM",
		"languages": ["comorian", "arabic", "french"],
		"flag_colors": ["green", "yellow", "white", "red", "blue"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Сент-Китс и Невис",
		"code": "KN",
		"languages": ["english"],
		"flag_colors": ["green", "red", "black", "yellow", "white"],
		"region": "Caribbean"
	},
	{
		"name": "Северная Корея",
		"code": "KP",
		"languages": ["korean"],
		"flag_colors": ["red", "blue", "white"],
		"region": "East Asia"
	},
	{
		"name": "Южная Корея",
		"code": "KR",
		"languages": ["korean"],
		"flag_colors": ["white", "red", "blue", "black"],
		"region": "East Asia"
	},
	{
		"name": "Кувейт",
		"code": "KW",
		"languages": ["arabic"],
		"flag_colors": ["green", "white", "red", "black"],
		"region": "Middle East"
	},
	{
		"name": "Каймановы острова",
		"code": "KY",
		"languages": ["english"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Казахстан",
		"code": "KZ",
		"languages": ["kazakh", "russian"],
		"flag_colors": ["blue", "yellow"],
		"region": "Central Asia"
	},
	{
		"name": "Лаос",
		"code": "LA",
		"languages": ["lao"],
		"flag_colors": ["red", "blue", "white"],
		"region": "Southeast Asia"
	},
	{
		"name": "Ливан",
		"code": "LB",
		"languages": ["arabic"],
		"flag_colors": ["red", "white", "green"],
		"region": "Middle East"
	},
	{
		"name": "Сент-Люсия",
		"code": "LC",
		"languages": ["english"],
		"flag_colors": ["blue", "yellow", "black", "white"],
		"region": "Caribbean"
	},
	{
		"name": "Лихтенштейн",
		"code": "LI",
		"languages": ["german"],
		"flag_colors": ["blue", "red", "yellow"],
		"region": "Western Europe"
	},
	{
		"name": "Шри-Ланка",
		"code": "LK",
		"languages": ["sinhala", "tamil"],
		"flag_colors": ["yellow", "green", "orange", "red"],
		"region": "South Asia"
	},
	{
		"name": "Либерия",
		"code": "LR",
		"languages": ["english"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Лесото",
		"code": "LS",
		"languages": ["sesotho", "english"],
		"flag_colors": ["blue", "white", "green", "black"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Литва",
		"code": "LT",
		"languages": ["lithuanian"],
		"flag_colors": ["yellow", "green", "red"],
		"region": "Northern Europe"
	},
	{
		"name": "Люксембург",
		"code": "LU",
		"languages": ["luxembourgish", "french", "german"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Western Europe"
	},
	{
		"name": "Латвия",
		"code": "LV",
		"languages": ["latvian"],
		"flag_colors": ["red", "white"],
		"region": "Northern Europe"
	},
	{
		"name": "Ливия",
		"code": "LY",
		"languages": ["arabic"],
		"flag_colors": ["red", "black", "green", "white"],
		"region": "North Africa"
	},
	{
		"name": "Марокко",
		"code": "MA",
		"languages": ["arabic", "tamazight"],
		"flag_colors": ["red", "green"],
		"region": "North Africa"
	},
	{
		"name": "Монако",
		"code": "MC",
		"languages": ["french"],
		"flag_colors": ["red", "white"],
		"region": "Western Europe"
	},
	{
		"name": "Молдова",
		"code": "MD",
		"languages": ["romanian"],
		"flag_colors": ["blue", "yellow", "red"],
		"region": "Eastern Europe"
	},
	{
		"name": "Черногория",
		"code": "ME",
		"languages": ["montenegrin"],
		"flag_colors": ["red", "yellow"],
		"region": "Southern Europe"
	},
	{
		"name": "Сен-Мартен",
		"code": "MF",
		"languages": ["french"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Мадагаскар",
		"code": "MG",
		"languages": ["malagasy", "french"],
		"flag_colors": ["white", "red", "green"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Маршалловы острова",
		"code": "MH",
		"languages": ["marshallese", "english"],
		"flag_colors": ["blue", "white", "orange"],
		"region": "Oceania"
	},
	{
		"name": "Северная Македония",
		"code": "MK",
		"languages": ["macedonian", "albanian"],
		"flag_colors": ["red", "yellow"],
		"region": "Southern Europe"
	},
	{
		"name": "Мали",
		"code": "ML",
		"languages": ["french"],
		"flag_colors": ["green", "yellow", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Мьянма",
		"code": "MM",
		"languages": ["burmese"],
		"flag_colors": ["yellow", "green", "red", "white"],
		"region": "Southeast Asia"
	},
	{
		"name": "Монголия",
		"code": "MN",
		"languages": ["mongolian"],
		"flag_colors": ["red", "blue", "yellow"],
		"region": "East Asia"
	},
	{
		"name": "Макао",
		"code": "MO",
		"languages": ["cantonese", "portuguese"],
		"flag_colors": ["green", "white", "yellow"],
		"region": "East Asia"
	},
	{
		"name": "Северные Марианские острова",
		"code": "MP",
		"languages": ["english", "chamorro", "carolinian"],
		"flag_colors": ["blue", "white"],
		"region": "Oceania"
	},
	{
		"name": "Мартиника",
		"code": "MQ",
		"languages": ["french"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Мавритания",
		"code": "MR",
		"languages": ["arabic"],
		"flag_colors": ["green", "yellow", "red"],
		"region": "North Africa"
	},
	{
		"name": "Монтсеррат",
		"code": "MS",
		"languages": ["english"],
		"flag_colors": ["blue", "green", "white", "yellow", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Мальта",
		"code": "MT",
		"languages": ["maltese", "english"],
		"flag_colors": ["white", "red"],
		"region": "Southern Europe"
	},
	{
		"name": "Маврикий",
		"code": "MU",
		"languages": ["english", "french", "mauritian creole"],
		"flag_colors": ["red", "blue", "yellow", "green"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Мальдивы",
		"code": "MV",
		"languages": ["divehi"],
		"flag_colors": ["red", "green", "white"],
		"region": "South Asia"
	},
	{
		"name": "Малави",
		"code": "MW",
		"languages": ["english", "chichewa"],
		"flag_colors": ["black", "red", "green"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Мексика",
		"code": "MX",
		"languages": ["spanish"],
		"flag_colors": ["green", "white", "red"],
		"region": "North America"
	},
	{
		"name": "Малайзия",
		"code": "MY",
		"languages": ["malay"],
		"flag_colors": ["red", "white", "blue", "yellow"],
		"region": "Southeast Asia"
	},
	{
		"name": "Мозамбик",
		"code": "MZ",
		"languages": ["portuguese"],
		"flag_colors": ["green", "black", "yellow", "white", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Намибия",
		"code": "NA",
		"languages": ["english"],
		"flag_colors": ["blue", "red", "green", "white", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Новая Каледония",
		"code": "NC",
		"languages": ["french"],
		"flag_colors": ["blue", "red", "green", "yellow", "black"],
		"region": "Oceania"
	},
	{
		"name": "Нигер",
		"code": "NE",
		"languages": ["french"],
		"flag_colors": ["orange", "white", "green"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Остров Норфолк",
		"code": "NF",
		"languages": ["english", "norfuk"],
		"flag_colors": ["green", "white"],
		"region": "Oceania"
	},
	{
		"name": "Нигерия",
		"code": "NG",
		"languages": ["english"],
		"flag_colors": ["green", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Никарагуа",
		"code": "NI",
		"languages": ["spanish"],
		"flag_colors": ["blue", "white"],
		"region": "Central America"
	},
	{
		"name": "Нидерланды",
		"code": "NL",
		"languages": ["dutch"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Western Europe"
	},
	{
		"name": "Норвегия",
		"code": "NO",
		"languages": ["norwegian"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Northern Europe"
	},
	{
		"name": "Непал",
		"code": "NP",
		"languages": ["nepali"],
		"flag_colors": ["red", "blue", "white"],
		"region": "South Asia"
	},
	{
		"name": "Науру",
		"code": "NR",
		"languages": ["nauruan", "english"],
		"flag_colors": ["blue", "yellow", "white"],
		"region": "Oceania"
	},
	{
		"name": "Ниуэ",
		"code": "NU",
		"languages": ["niuean", "english"],
		"flag_colors": ["yellow", "blue", "white", "red"],
		"region": "Oceania"
	},
	{
		"name": "Новая Зеландия",
		"code": "NZ",
		"languages": ["english", "maori"],
		"flag_colors": ["blue", "red", "white"],
		"region": "Oceania"
	},
	{
		"name": "Оман",
		"code": "OM",
		"languages": ["arabic"],
		"flag_colors": ["red", "white", "green"],
		"region": "Middle East"
	},
	{
		"name": "Панама",
		"code": "PA",
		"languages": ["spanish"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Central America"
	},
	{
		"name": "Перу",
		"code": "PE",
		"languages": ["spanish", "quechua", "aymara"],
		"flag_colors": ["red", "white"],
		"region": "South America"
	},
	{
		"name": "Французская Полинезия",
		"code": "PF",
		"languages": ["french", "tahitian"],
		"flag_colors": ["red", "white"],
		"region": "Oceania"
	},
	{
		"name": "Папуа — Новая Гвинея",
		"code": "PG",
		"languages": ["english", "tok pisin", "hiri motu"],
		"flag_colors": ["red", "black", "yellow", "white"],
		"region": "Oceania"
	},
	{
		"name": "Филиппины",
		"code": "PH",
		"languages": ["filipino", "english"],
		"flag_colors": ["blue", "red", "white", "yellow"],
		"region": "Southeast Asia"
	},
	{
		"name": "Пакистан",
		"code": "PK",
		"languages": ["urdu", "english"],
		"flag_colors": ["green", "white"],
		"region": "South Asia"
	},
	{
		"name": "Польша",
		"code": "PL",
		"languages": ["polish"],
		"flag_colors": ["white", "red"],
		"region": "Eastern Europe"
	},
	{
		"name": "Сен-Пьер и Микелон",
		"code": "PM",
		"languages": ["french"],
		"flag_colors": ["blue", "white", "red", "yellow", "black"],
		"region": "North America"
	},
	{
		"name": "Острова Питкэрн",
		"code": "PN",
		"languages": ["english", "pitkern"],
		"flag_colors": ["blue", "green", "yellow", "red", "white"],
		"region": "Oceania"
	},
	{
		"name": "Пуэрто-Рико",
		"code": "PR",
		"languages": ["spanish", "english"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Caribbean"
	},
	{
		"name": "Палестина",
		"code": "PS",
		"languages": ["arabic"],
		"flag_colors": ["red", "green", "white", "black"],
		"region": "Middle East"
	},
	{
		"name": "Португалия",
		"code": "PT",
		"languages": ["portuguese"],
		"flag_colors": ["green", "red", "yellow"],
		"region": "Southern Europe"
	},
	{
		"name": "Палау",
		"code": "PW",
		"languages": ["palauan", "english"],
		"flag_colors": ["blue", "yellow"],
		"region": "Oceania"
	},
	{
		"name": "Парагвай",
		"code": "PY",
		"languages": ["spanish", "guarani"],
		"flag_colors": ["red", "white", "blue", "yellow"],
		"region": "South America"
	},
	{
		"name": "Катар",
		"code": "QA",
		"languages": ["arabic"],
		"flag_colors": ["red", "white"],
		"region": "Middle East"
	},
	{
		"name": "Реюньон",
		"code": "RE",
		"languages": ["french", "reunion creole"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Румыния",
		"code": "RO",
		"languages": ["romanian"],
		"flag_colors": ["blue", "yellow", "red"],
		"region": "Eastern Europe"
	},
	{
		"name": "Сербия",
		"code": "RS",
		"languages": ["serbian"],
		"flag_colors": ["red", "blue", "white", "yellow"],
		"region": "Eastern Europe"
	},
	{
		"name": "Россия",
		"code": "RU",
		"languages": ["russian"],
		"flag_colors": ["white", "blue", "red"],
		"region": "Eastern Europe"
	},
	{
		"name": "Руанда",
		"code": "RW",
		"languages": ["kinyarwanda", "french", "english"],
		"flag_colors": ["blue", "yellow", "green"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Саудовская Аравия",
		"code": "SA",
		"languages": ["arabic"],
		"flag_colors": ["green", "white"],
		"region": "Middle East"
	},
	{
		"name": "Соломоновы острова",
		"code": "SB",
		"languages": ["english"],
		"flag_colors": ["blue", "green", "yellow", "white"],
		"region": "Oceania"
	},
	{
		"name": "Сейшельские острова",
		"code": "SC",
		"languages": ["seychellois creole", "english", "french"],
		"flag_colors": ["blue", "yellow", "red", "white", "green"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Судан",
		"code": "SD",
		"languages": ["arabic", "english"],
		"flag_colors": ["red", "white", "black", "green"],
		"region": "North Africa"
	},
	{
		"name": "Швеция",
		"code": "SE",
		"languages": ["swedish"],
		"flag_colors": ["blue", "yellow"],
		"region": "Northern Europe"
	},
	{
		"name": "Сингапур",
		"code": "SG",
		"languages": ["english", "malay", "mandarin", "tamil"],
		"flag_colors": ["red", "white"],
		"region": "Southeast Asia"
	},
	{
		"name": "Остров Святой Елены",
		"code": "SH",
		"languages": ["english"],
		"flag_colors": ["blue", "red", "white", "yellow", "green"],
		"region": "Atlantic Ocean"
	},
	{
		"name": "Словения",
		"code": "SI",
		"languages": ["slovenian"],
		"flag_colors": ["white", "blue", "red"],
		"region": "Southern Europe"
	},
	{
		"name": "Шпицберген и Ян-Майен",
		"code": "SJ",
		"languages": ["norwegian"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Northern Europe"
	},
	{
		"name": "Словакия",
		"code": "SK",
		"languages": ["slovak"],
		"flag_colors": ["white", "blue", "red"],
		"region": "Eastern Europe"
	},
	{
		"name": "Сьерра-Леоне",
		"code": "SL",
		"languages": ["english"],
		"flag_colors": ["green", "white", "blue"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Сан-Марино",
		"code": "SM",
		"languages": ["italian"],
		"flag_colors": ["white", "blue"],
		"region": "Southern Europe"
	},
	{
		"name": "Сенегал",
		"code": "SN",
		"languages": ["french"],
		"flag_colors": ["green", "yellow", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Сомали",
		"code": "SO",
		"languages": ["somali", "arabic"],
		"flag_colors": ["blue", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Суринам",
		"code": "SR",
		"languages": ["dutch"],
		"flag_colors": ["green", "white", "red", "yellow"],
		"region": "South America"
	},
	{
		"name": "Южный Судан",
		"code": "SS",
		"languages": ["english"],
		"flag_colors": ["black", "red", "green", "blue", "white", "yellow"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Сан-Томе и Принсипи",
		"code": "ST",
		"languages": ["portuguese"],
		"flag_colors": ["green", "yellow", "red", "black"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Сальвадор",
		"code": "SV",
		"languages": ["spanish"],
		"flag_colors": ["blue", "white"],
		"region": "Central America"
	},
	{
		"name": "Синт-Мартен",
		"code": "SX",
		"languages": ["dutch", "english"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Caribbean"
	},
	{
		"name": "Сирия",
		"code": "SY",
		"languages": ["arabic"],
		"flag_colors": ["red", "white", "black", "green"],
		"region": "Middle East"
	},
	{
		"name": "Эсватини",
		"code": "SZ",
		"languages": ["swazi", "english"],
		"flag_colors": ["blue", "red", "yellow", "black", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Острова Тёркс и Кайкос",
		"code": "TC",
		"languages": ["english"],
		"flag_colors": ["blue", "red", "white", "yellow", "green"],
		"region": "Caribbean"
	},
	{
		"name": "Чад",
		"code": "TD",
		"languages": ["french", "arabic"],
		"flag_colors": ["blue", "yellow", "red"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Французские Южные территории",
		"code": "TF",
		"languages": ["french"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Oceania"
	},
	{
		"name": "Того",
		"code": "TG",
		"languages": ["french"],
		"flag_colors": ["green", "yellow", "red", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Таиланд",
		"code": "TH",
		"languages": ["thai"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Southeast Asia"
	},
	{
		"name": "Таджикистан",
		"code": "TJ",
		"languages": ["tajik"],
		"flag_colors": ["red", "white", "green", "yellow"],
		"region": "Central Asia"
	},
	{
		"name": "Токелау",
		"code": "TK",
		"languages": ["tokelauan", "english"],
		"flag_colors": ["blue", "yellow", "white"],
		"region": "Oceania"
	},
	{
		"name": "Восточный Тимор",
		"code": "TL",
		"languages": ["tetum", "portuguese"],
		"flag_colors": ["red", "yellow", "black", "white"],
		"region": "Southeast Asia"
	},
	{
		"name": "Туркменистан",
		"code": "TM",
		"languages": ["turkmen"],
		"flag_colors": ["green", "red", "white"],
		"region": "Central Asia"
	},
	{
		"name": "Тунис",
		"code": "TN",
		"languages": ["arabic"],
		"flag_colors": ["red", "white"],
		"region": "North Africa"
	},
	{
		"name": "Тонга",
		"code": "TO",
		"languages": ["tongan", "english"],
		"flag_colors": ["red", "white"],
		"region": "Oceania"
	},
	{
		"name": "Турция",
		"code": "TR",
		"languages": ["turkish"],
		"flag_colors": ["red", "white"],
		"region": "Middle East"
	},
	{
		"name": "Тринидад и Тобаго",
		"code": "TT",
		"languages": ["english"],
		"flag_colors": ["red", "black", "white"],
		"region": "Caribbean"
	},
	{
		"name": "Тувалу",
		"code": "TV",
		"languages": ["tuvaluan", "english"],
		"flag_colors": ["blue", "yellow", "red", "white"],
		"region": "Oceania"
	},
	{
		"name": "Тайвань",
		"code": "TW",
		"languages": ["mandarin"],
		"flag_colors": ["red", "blue", "white"],
		"region": "East Asia"
	},
	{
		"name": "Танзания",
		"code": "TZ",
		"languages": ["swahili", "english"],
		"flag_colors": ["green", "yellow", "black", "blue"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Украина",
		"code": "UA",
		"languages": ["ukrainian"],
		"flag_colors": ["blue", "yellow"],
		"region": "Eastern Europe"
	},
	{
		"name": "Уганда",
		"code": "UG",
		"languages": ["english", "swahili"],
		"flag_colors": ["black", "yellow", "red", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "США",
		"code": "US",
		"languages": ["english"],
		"flag_colors": ["red", "white", "blue"],
		"region": "North America"
	},
	{
		"name": "Уругвай",
		"code": "UY",
		"languages": ["spanish"],
		"flag_colors": ["white", "blue", "yellow"],
		"region": "South America"
	},
	{
		"name": "Узбекистан",
		"code": "UZ",
		"languages": ["uzbek"],
		"flag_colors": ["blue", "white", "green", "red"],
		"region": "Central Asia"
	},
	{
		"name": "Ватикан",
		"code": "VA",
		"languages": ["italian", "latin"],
		"flag_colors": ["yellow", "white"],
		"region": "Southern Europe"
	},
	{
		"name": "Сент-Винсент и Гренадины",
		"code": "VC",
		"languages": ["english"],
		"flag_colors": ["blue", "yellow", "green", "white"],
		"region": "Caribbean"
	},
	{
		"name": "Венесуэла",
		"code": "VE",
		"languages": ["spanish"],
		"flag_colors": ["yellow", "blue", "red", "white"],
		"region": "South America"
	},
	{
		"name": "Британские Виргинские острова",
		"code": "VG",
		"languages": ["english"],
		"flag_colors": ["blue", "white", "red"],
		"region": "Caribbean"
	},
	{
		"name": "Виргинские острова США",
		"code": "VI",
		"languages": ["english"],
		"flag_colors": ["red", "white", "blue", "yellow"],
		"region": "Caribbean"
	},
	{
		"name": "Вьетнам",
		"code": "VN",
		"languages": ["vietnamese"],
		"flag_colors": ["red", "yellow"],
		"region": "Southeast Asia"
	},
	{
		"name": "Вануату",
		"code": "VU",
		"languages": ["bislama", "english", "french"],
		"flag_colors": ["red", "green", "black", "yellow"],
		"region": "Oceania"
	},
	{
		"name": "Уоллис и Футуна",
		"code": "WF",
		"languages": ["french", "wallisian", "futunan"],
		"flag_colors": ["red", "white", "blue"],
		"region": "Oceania"
	},
	{
		"name": "Самоа",
		"code": "WS",
		"languages": ["samoan", "english"],
		"flag_colors": ["red", "blue", "white"],
		"region": "Oceania"
	},
	{
		"name": "Косово",
		"code": "XK",
		"languages": ["albanian", "serbian"],
		"flag_colors": ["blue", "yellow", "white"],
		"region": "Eastern Europe"
	},
	{
		"name": "Йемен",
		"code": "YE",
		"languages": ["arabic"],
		"flag_colors": ["red", "white", "black"],
		"region": "Middle East"
	},
	{
		"name": "Майотта",
		"code": "YT",
		"languages": ["french", "shimaore", "kibushi"],
		"flag_colors": ["white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "ЮАР",
		"code": "ZA",
		"languages": ["zulu", "xhosa", "afrikaans", "english"],
		"flag_colors": ["red", "blue", "green", "yellow", "black", "white"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Замбия",
		"code": "ZM",
		"languages": ["english"],
		"flag_colors": ["green", "red", "black", "orange"],
		"region": "Sub-Saharan Africa"
	},
	{
		"name": "Зимбабве",
		"code": "ZW",
		"languages": ["english", "shona", "ndebele"],
		"flag_colors": ["green", "yellow", "red", "black", "white"],
		"region": "Sub-Saharan Africa"
	}
];
